import { BRAZIL_LABEL_SECTIONS } from './brazilSectionCatalog';
import {
  SectionMappingMode,
  SectionMappingPutBody,
  SectionPageMap,
  SectionPageValues
} from './types';

/** China-style default: every catalog section starts at page 0. */
export const createDefaultSectionPages = (): SectionPageValues =>
  Object.fromEntries(BRAZIL_LABEL_SECTIONS.map(section => [section.key, '0']));

/** Merge saved section map onto catalog defaults (all sections always shown). */
export const sectionMapToPageValues = (sectionMap: SectionPageMap): SectionPageValues => {
  const values = createDefaultSectionPages();
  Object.entries(sectionMap ?? {}).forEach(([key, entry]) => {
    if (entry?.page_number !== undefined && entry.page_number !== null) {
      values[key] = String(entry.page_number);
    }
  });
  return values;
};

/** Normalize GET qc_status (e.g. "To_qc") to PUT value (e.g. "to_qc"). */
export const normalizePageMappingQcStatus = (status: string): string => {
  const normalized = status.trim().toLowerCase().replace(/\s+/g, '_');
  if (normalized === 'qced' || normalized === 'to_qc') {
    return normalized;
  }
  return 'to_qc';
};

/** Build API SectionMap from form page values (catalog keys + headings). */
export const pageValuesToSectionMap = (pages: SectionPageValues): SectionPageMap => {
  const map: SectionPageMap = {};
  BRAZIL_LABEL_SECTIONS.forEach(({ key, label }) => {
    const parsed = Number.parseInt(pages[key] ?? '0', 10);
    map[key] = {
      page_number: Number.isNaN(parsed) ? 0 : parsed,
      heading: label
    };
  });
  return map;
};

export const buildSectionMappingPutBody = (
  mode: SectionMappingMode,
  pages: SectionPageValues,
  qcStatus: string,
  curatorName: string,
  curatorEmail: string,
  s3Path?: string
): SectionMappingPutBody => {
  const sectionMap = pageValuesToSectionMap(pages);
  const body: SectionMappingPutBody = {
    curation_type: mode,
    qc_status: normalizePageMappingQcStatus(qcStatus),
    curator_name: curatorName,
    curator_email: curatorEmail
  };

  if (mode === 'section') {
    body.sections = sectionMap;
  } else {
    body.sections_original = sectionMap;
  }

  if (s3Path) {
    body.s3_path = s3Path;
  }

  return body;
};
